import type { CartProduct } from "./ProductLine";

export const DISCOUNT_AMOUNT_TYPES = {
  RIP: "rip",
  DOLLARS_PER_CASE: "dollars_per_case",
  QUANTITY_WITH_REQUIREMENTS: "quantity_with_requirements",
  TEXT: "text",
};

export interface SimpleCartDiscount {
  id: number;
  amount: number;
  amount_type: string;
  case_count: number;
  discount_per_unit: number;
  plain_text: string;
  target_container: string;
  deal_tier_id: number;
  product_group_id: string;
  discount_type: string;
  is_mix_match: boolean;
}

export interface OrderProductDiscount {
  just_an_upsell: boolean;
  discount: SimpleCartDiscount;
  next_discount: SimpleCartDiscount;
}
export interface Discount {
  deal_id: number;
  deal_tier_id: number;
  discount_per_unit: number;
  id: number;
  inventory_id: number;
  minimum_purchase_units: number;
  target_container: string;
  discount_string: string;
  deal_tier_name: string;
  deal_tier_label: string;
  product_id: number;
  cartProduct?: CartProduct;
  product_line_name: string;
  discount_unit_label?: string;
  case_count?: number;
  product_line_id: number;
  unit_type: string;
  unit_price: number;
  case_price: number;
  container_type: string;
  container_case_size: number;
  amount_type?: string;
  amount?: number;
  quantity_deal?: boolean;
  active_discount?: boolean;
  price_group_description?: string;
  price_group_id?: string;
  price_group_name?: string;
  distributor_uses_warehouse_pickup?: boolean;
}

export interface DealTier {
  deal_id: number;
  deal_tier_id: number;
  deal_tier_label: string;
  deal_tier_name: string;
  distributor_id: number;
  distributor_name: string;
  ends_at: string | null;
  has_storefront: boolean;
  minimum_purchase_units: number;
  starts_at: string;
  tier_max_label: string;
  tier_min_label: string;
  discounts: Discount[];
  tier_available_label: string;
  container_label: string;
  tier_discount_amount: string;
  amount_type?: string;
  active_deal: boolean;
}

export interface Deal {
  tiers: DealTier[];
}

export interface DealResponse {
  deal: HappyHourDeal;
  distributor: HappyHourDealDistributor;
}

export interface HappyHourDealDistributor {
  id: number;
  name: string;
  has_storefront: boolean;
}

export interface HappyHourDeal {
  channels: string[];
  displayName: string;
  distributorId: string;
  isRip: boolean;
  locationInfo: object;
  productGroupId: string;
  tiers: HappyHourDealTier[];
  unconnectedAccount: boolean;
}

export interface HappyHourDealTier {
  tier: number;
  tierUom: "CASE" | "UNIT";
  maxDiscountLabel: string;
  quantityLabel: string;
  products: HappyHourDealProduct[];
}

export interface HappyHourDealProduct {
  brand_family_name: string;
  container_carton_size: number | null;
  container_case_size: number | null;
  container_size: string;
  container_type: string;
  container_units: string;
  discount: {
    sku: string;
    priceType: string;
    valueUom: string;
    originalValueUom: string;
    discountValue: {
      unitValue?: number;
      caseValue?: number;
    };
    minimumCount: {
      unitValue?: number;
      caseAmount?: number;
    };
    assigneeSource: object;
    productGroupId: string;
    startDateTime: string;
    endDateTime?: string;
  };
  frontlinePrice: {
    unitPrice?: number;
    casePrice?: number;
  };
  inventory_id: number;
  product_id: number;
  product_line_id: number;
  product_line_name: string;
  sku: string;
  vintage_year: string | null;
}

export interface MixDeal {
  deal_id: number;
  discounts: Discount[];
}

export interface DealProgress {
  deal_id: number;
  deal_tier_id: number;
  progress: number;
  quantity: number;
  total: number;
}
